import type { LocalCalendarEntry, LinkedCalendarEntry } from 'owa-graph-schema';

/**
 * Gets the calendar owner's SMTP address for a calendar entry.
 *
 * @param calendarEntry Local or linked calendar entry (or undefined)
 * @returns Owner SMTP address if both an owner email and display name are present; otherwise undefined.
 */
export function getCalendarOwnerForCalendarEntry(
    calendarEntry: LocalCalendarEntry | LinkedCalendarEntry | undefined
): string | undefined {
    if (!calendarEntry) {
        return undefined;
    }

    const localCalendarEntry = calendarEntry as LocalCalendarEntry;
    if (localCalendarEntry.SharedOwnerEmailAddress && localCalendarEntry.SharedOwnerName) {
        return localCalendarEntry.SharedOwnerEmailAddress;
    }

    const linkedCalendarEntry = calendarEntry as LinkedCalendarEntry;
    if (linkedCalendarEntry.OwnerEmailAddress && linkedCalendarEntry.OwnerName) {
        return linkedCalendarEntry.OwnerEmailAddress;
    }

    return undefined;
}
